import { useGetContractFamilyPipelineConfigurationQuery } from "@/api/contract-family-pipeline";
import { useContractFamiliesAccess } from "@/hooks/use-contract-families-access";
import type { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";

/**
 * Only base collections of the organisation's supplier template can be summarised into the Supplier
 * Summaries Collection: never another template's collection and never a Master Collection itself.
 */
export const useCanSummariseSupplierCollection = (
  snapshotCollection: Pick<SnapshotCollection, "id" | "business_report_id" | "is_family_collection">,
): boolean => {
  const { hasContractFamilies } = useContractFamiliesAccess();
  const configuration = useGetContractFamilyPipelineConfigurationQuery(undefined, { skip: !hasContractFamilies });

  return (
    hasContractFamilies &&
    Boolean(configuration.isSuccess) &&
    !!configuration.data?.fixed_template_id &&
    configuration.data.fixed_template_id === snapshotCollection.business_report_id &&
    configuration.data.default_family_collection_id !== snapshotCollection.id &&
    !snapshotCollection.is_family_collection
  );
};
